<template>
  <div>
    <div>
      <DashboardTemplate>
        <div v-if="getRule === 'startup'">
          <StartupDashboard />
        </div>
        <div v-else-if="getRule === 'board'">
          <Maintenance />
        </div>
        <div v-else-if="getRule === 'board' || getRule === 'exclusiveboard'">
          <!-- <div v-else-if="getRule ==='staff'"> -->
          <ExclusiveDashboard />
        </div>
        <div v-else-if="getRule === 'staff' || getRule === 'admin'">
          <!-- <div v-else-if="getRule ==='staff'"> -->
          <AdminAndStaffDashboard />
        </div>
        <div v-else>
          <!-- <ExclusiveDashboard /> -->
          <SignUpLink />
        </div>
      </DashboardTemplate>
    </div>
  </div>
</template>
<script>
// @ is an alias to /src
import Maintenance from "@/components/Maintenance.vue";
import ExclusiveTemplate from "@/template/ExclusiveTemplate.vue";
import DashboardTemplate from "@/template/DashboardTemplate.vue";
import SignUpLink from "@/components/SignUpLink.vue";
import StartupDashboard from "@/components/StartupDashboard.vue";
import AdminAndStaffDashboard from "@/components/AdminAndStaffDashboard.vue";
import ExclusiveDashboard from "@/components/ExclusiveDashboard.vue";

export default {
  name: "dashboard",
  components: {
    Maintenance,
    DashboardTemplate,
    ExclusiveDashboard,
    SignUpLink,
    StartupDashboard,
    ExclusiveTemplate,
    AdminAndStaffDashboard,
  },
  created() {},
  computed: {
    getRule() {
      return this.$store.getters.getRule;
    },
  },
};
</script>
